(() => {
  "use strict";

  if (window.prolashLineItemOfferLoaded) return;

const settingsElement = document.getElementById(
  "prolash-cart-promo-settings"
);

if (!settingsElement) return;

let themeSettings;

try {
  themeSettings = JSON.parse(settingsElement.textContent);
} catch (error) {
  console.warn("Could not read cart promotional settings.", error);
  return;
}

if (!themeSettings || typeof themeSettings !== "object") return;

const config = {
  enabled: themeSettings.enabled === true,
  productId: String(themeSettings.productId || "").trim(),
  message: String(themeSettings.message || "").trim(),
  cartRefreshInterval: 2000
};

// Do not initialize if disabled, unconfigured, or empty.
if (
  !config.enabled ||
  !/^\d+$/.test(config.productId) ||
  !config.message
) {
  return;
}

window.prolashLineItemOfferLoaded = true;


  const messageSelector = "[data-prolash-product-offer]";
  const root = window.Shopify?.routes?.root || "/";
  const cartUrl = `${root}cart.js`;

  let cartItems = [];
  let cartVerified = false;
  let requestInProgress = false;
  let drawers = [];

  // Find drawers in regular HTML and accessible open shadow roots.
  function findDrawers(root = document, results = []) {
    root.querySelectorAll("#cart-drawer").forEach((drawer) => {
      results.push(drawer);
    });

    root.querySelectorAll("*").forEach((element) => {
      if (element.shadowRoot) {
        findDrawers(element.shadowRoot, results);
      }
    });

    return results;
  }

  function createMessage() {
    const message = document.createElement("div");
    message.setAttribute("data-prolash-product-offer", "");
    message.setAttribute("role", "status");

    Object.assign(message.style, {
      display: "block",
      boxSizing: "border-box",
      width: "100%",
      flexShrink: "0",
      margin: "0",
      padding: "12px 14px",
      background:
        "linear-gradient(135deg, rgb(251 243 232) 0%, #fffefd 100%)",
      border: "1px solid rgb(126 100 64)",
      borderRadius: "12px",
      color: "#35252d",
      fontFamily: "inherit",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.6",
      textAlign: "left",
      boxShadow: "0 2px 8px rgba(126, 100, 64, 0.04)"
    });

    // Safely preserve the message text while emphasizing FREE.
    const parts = config.message.split(/\bfree\b/gi);

    parts.forEach((part, index) => {
      if (index > 0) {
        const emphasis = document.createElement("strong");
        emphasis.textContent = "FREE";

        Object.assign(emphasis.style, {
          color: "var(--sand, #7e6440)",
          fontWeight: "700"
        });

        message.appendChild(emphasis);
      }

      message.appendChild(document.createTextNode(part));
    });

    return message;
  }

  function removeMessages(container) {
    container.querySelectorAll(messageSelector).forEach((message) => {
      message.remove();
    });
  }

  function renderMessages() {
    for (const drawer of drawers) {
      if (!drawer.isConnected) continue;

      const productList = drawer.querySelector('section[role="list"]');

      if (!cartVerified || !productList) {
        removeMessages(drawer);
        continue;
      }

      // Direct cart items only; exclude recommendation cards.
      const renderedItems = [
        ...productList.querySelectorAll(':scope > [role="listitem"]')
      ];

      // Avoid mapping a partially updated drawer to a different cart.
      if (renderedItems.length !== cartItems.length) {
        removeMessages(drawer);
        continue;
      }

      const eligibleItems = new Set();

      renderedItems.forEach((element, index) => {
        const cartItem = cartItems[index];

        if (
          String(cartItem.product_id) === config.productId &&
          cartItem.quantity > 0
        ) {
          eligibleItems.add(element);
        }
      });

      // Remove old drawer-level messages and ineligible item messages.
      drawer.querySelectorAll(messageSelector).forEach((message) => {
        if (!eligibleItems.has(message.parentElement)) {
          message.remove();
        }
      });

      for (const element of eligibleItems) {
        const existing = [
          ...element.querySelectorAll(messageSelector)
        ];

        let message = existing.shift();

        // Ensure only one message per cart line.
        existing.forEach((duplicate) => duplicate.remove());

        if (!message) {
          message = createMessage();
        }

        // Append beneath this line item's image, details and controls.
        // The existing flex-column gap supplies spacing above it.
        if (element.lastElementChild !== message) {
          element.appendChild(message);
        }
      }
    }
  }

  async function refreshCart() {
    if (requestInProgress || document.hidden) return;

    requestInProgress = true;

    try {
      const response = await fetch(cartUrl, {
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const cart = await response.json();

      if (!Array.isArray(cart.items)) {
        throw new Error("Unexpected cart response.");
      }

      cartItems = cart.items;
      cartVerified = true;

      // Refresh references in case the drawer was replaced.
      drawers = findDrawers();
      renderMessages();
    } catch (error) {
      cartVerified = false;
      cartItems = [];
      renderMessages();

      console.warn("Could not verify the cart offer.", error);
    } finally {
      requestInProgress = false;
    }
  }

  function discoverAndRender() {
    if (document.hidden) return;

    drawers = findDrawers();
    renderMessages();
  }

  function start() {
    if (!/^\d+$/.test(config.productId)) {
      console.warn("Cart offer: configure a valid Shopify product ID.");
      return;
    }

    discoverAndRender();
    refreshCart();

    // Restore messages after drawer mounting or re-rendering.
    window.setInterval(discoverAndRender, 1000);

    // Refresh cart data while the drawer is mounted.
    window.setInterval(() => {
      if (drawers.some((drawer) => drawer.isConnected)) {
        refreshCart();
      }
    }, config.cartRefreshInterval);

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        discoverAndRender();
        refreshCart();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
